import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Typography,
  Button,
  TextField,
  Box,
  CircularProgress,
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { cancelBillingLinkRequest } from '../../../actions/user';

const ConsolidatedBillingRequestPending = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [submitting, setSubmitting] = useState(false);

  const handleCancel = async () => {
    setSubmitting(true);
    await dispatch(cancelBillingLinkRequest());
    setSubmitting(false);
  };

  return (
    <Box>
      <Typography variant='h5' gutterBottom>
        Your request is pending
      </Typography>
      <TextField
        fullWidth
        label='Consolidated Billing Account Email'
        value={user.requested_billing_email}
        disabled
        sx={{ mb: 2 }}
      />
      <Button
        variant='contained'
        color='primary'
        onClick={handleCancel}
        disabled={submitting}
        startIcon={
          submitting ? (
            <CircularProgress size={20} color='inherit' />
          ) : (
            <CancelIcon />
          )
        }
      >
        {submitting ? 'Cancelling Request...' : 'Cancel Request'}
      </Button>
    </Box>
  );
};

export default ConsolidatedBillingRequestPending;
